import { IsString, IsBoolean } from 'class-validator';
import { DownloadFileDto } from './download-file.dto';


export class CreatePublishingDataDto {
  @IsString()
    slug: string;
  @IsString()
    shortDescription: string;
  @IsString()
    fullDescription: string;
  @IsString()
    benefits: string;
  @IsString()
    specificConditions: string;
  smallImage: DownloadFileDto | null;
  detailedImage: DownloadFileDto | null;
  @IsBoolean()
    isPublished: boolean;
  @IsBoolean()
    isSubdomain: boolean;
}

export class PublishingDataDto extends CreatePublishingDataDto {
  id: number;
}
